import Vue from 'vue'
import VueI18n from '../i18n'


// global methods
Vue.mixin({
    methods: {
      translate: str => { 
        return VueI18n.t("main." + str); 
      }
    }
})